import React from 'react'
import { useDispatch } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom' 
import { useSelector } from 'react-redux'

import {
    CCloseButton,
    CSidebar,
    CSidebarBrand,
    CSidebarFooter,
    CSidebarHeader,
    CSidebarToggler,
} from '@coreui/react-pro'

import { SidebarItems } from './SidebarItems'
import logo from '../../assets/images/ansa/ansa-logo.svg'

const Sidebar = () => {
    const unfoldable = false;
    const sidebarShow = useSelector((state) => state.sidebarShow)
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('permissions');

        navigate('/login');
    }
    const vars = {
        // '--cui-sidebar-width': "10px"
    }
    return (
        <CSidebar
            style={vars}
            colorScheme="dark"
            position="fixed"
            visible={sidebarShow}
            
            onVisibleChange={(visible) => {
            }}
        >
            <CSidebarHeader>
                <CSidebarBrand as={NavLink} to="/">
                    <img src={logo} alt="Brand Logo" height="24" />
                </CSidebarBrand>
                <CCloseButton
                    className="d-lg-none"
                    dark
                    onClick={() => dispatch({ type: 'set', sidebarShow: false })}
                />
            </CSidebarHeader>
            <SidebarItems />
              
        </CSidebar>
    )
}

export default React.memo(Sidebar)